import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconMessage from "@arco-design/web-react/icon/react-icon/IconMessage";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import { setAccessToken, setRefreshToken } from '@/utils/token';
import { InputLimit } from '@/utils/validate';
import locale from './locale';
import styles from './style/index.module.less';
export default function LoginForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const t = useLocale(locale);
  const [loginParams, setLoginParams] = useState({});
  const [corpList, setCorpList] = useState(null);
  const [needVerify, setNeedVerify] = useState(false);
  const [countdown, setCountdown] = useState(0);
  function afterLoginSuccess(accessToken, refreshToken, notCorp) {
    // 存储token到cookie
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
    if (notCorp) {
      history.push('/createCorp');
      return;
    }

    // 跳转首页
    window.location.href = '/';
  }
  function selectCorp(corpList) {
    setCorpList(corpList);
  }
  function login(params) {
    setErrorMessage('');
    setLoading(true);
    request.post('/v1/user/login', params).then(res => {
      const {
        code,
        message,
        data
      } = res.data;
      if (code === 202) {
        // 需要短信二次验证
        setNeedVerify(true);
        setLoginParams(params);
        setCorpList(null);
      } else if (code === 200) {
        if (data.corp_list && data.corp_list.length > 0) {
          setLoginParams(params);
          selectCorp(data.corp_list);
        } else if (data.access_token && data.refresh_token) {
          afterLoginSuccess(data.access_token, data.refresh_token, data.not_corp);
        } else {
          setErrorMessage(t['login.form.login.errMsg']);
        }
      } else {
        setErrorMessage(message || t['login.form.login.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      const params = {
        ...loginParams,
        ...values,
        corp_id: needVerify ? loginParams.corp_id : '0'
      };
      if (needVerify) {
        params.verify_code = values.verify_code;
      }
      login(params);
    }).catch(error => {
      // setErrorMessage(t['login.form.login.errMsg']);
    });
  }
  function onGetVerifyCodeClick() {
    setLoading(true);
    request.post('/v1/user/verify_code', {
      identifier: loginParams.identifier,
      type: 'login'
    }).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        setCountdown(60);
      } else {
        setErrorMessage(message || t['login.form.getVerifyCode.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  React.useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper'],
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, t['login.form.subtitle']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
    // initialValues={{
    //   identifier: 'shiwei.yuan@qq.com',
    //   password: 'zzb.666',
    // }}
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "identifier",
    rules: [{
      required: true,
      message: t['login.form.identifier.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    maxLength: InputLimit.email,
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['login.form.identifier.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    maxLength: InputLimit.password,
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), needVerify && /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title'],
    style: {
      marginBottom: 16
    }
  }, t['login.form.verify.subtitle']), needVerify && /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-verify-actions']
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "verify_code",
    rules: [{
      required: true,
      message: t['login.form.verifyCode.errMsg']
    }, {
      validator: (value, cb) => {
        if (!value) return cb();
        if (!/^\d{6}$/.test(value)) return cb(t['login.form.verifyCode.errMsg']);
        return cb();
      }
    }],
    style: {
      flex: 1,
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    prefix: /*#__PURE__*/React.createElement(_IconMessage, null),
    placeholder: t['login.form.verifyCode.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Button, {
    disabled: countdown > 0,
    type: "primary",
    onClick: onGetVerifyCodeClick,
    loading: loading,
    style: {
      marginLeft: 20
    }
  }, countdown > 0 ? `${countdown}s` : t['login.form.getVerifyCode'])), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical",
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Link, {
    onClick: () => history.push('/forgot')
  }, t['login.form.forgetPassword'])), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['login-form-register-btn'],
    onClick: () => history.push('/register')
  }, t['login.form.register']))), corpList && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'var(--color-bg-1)',
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-select-sub-title']
  }, t['login.form.corp.select']), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical",
    className: styles['login-select']
  }, corpList.map(item => /*#__PURE__*/React.createElement(_Button, {
    className: styles['login-select-btn'],
    key: item.corp_id,
    type: "outline",
    long: true,
    onClick: () => {
      login({
        ...loginParams,
        corp_id: item.corp_id
      });
    }
  }, item.corp_name)))));
}